import { useEffect, useState } from "react";
import api, { fmtDT, fmtDate } from "@/lib/api";
import { PageHeader, StatusBadge, Loading, EmptyState } from "@/components/Shared";
import { ClipboardList, Download } from "lucide-react";
import { DeliveryBadge, DeliveryUpdater } from "@/components/DeliveryStatus";

export default function SupplierOrders() {
  const [orders, setOrders] = useState(null);
  useEffect(() => { api.get("/supplier/orders").then((r) => setOrders(r.data)).catch(() => setOrders([])); }, []);

  const exportCSV = () => {
    const rows = [["Pharmacie", "Opération", "Produit", "Quantité", "Prix unitaire", "Total", "Date"]];
    orders.forEach((o) => o.items?.forEach((it) => rows.push([o.pharmacist_name, o.operation_name, it.name, it.qty, it.unit_price, it.total, o.created_at])));
    const csv = rows.map((r) => r.map((c) => `"${c}"`).join(",")).join("\n");
    const blob = new Blob([csv], { type: "text/csv" });
    const a = document.createElement("a");
    a.href = URL.createObjectURL(blob);
    a.download = "commandes.csv";
    a.click();
  };

  const onUpdated = (id, newStatus) => {
    setOrders((prev) => prev.map((o) => o.id === id ? { ...o, delivery_status: newStatus } : o));
  };

  if (orders === null) return <Loading />;

  return (
    <div>
      <PageHeader title="Commandes reçues" subtitle="Les commandes des pharmacies pour vos opérations.">
        {orders.length > 0 && (
          <button onClick={exportCSV} data-testid="export-orders" className="inline-flex items-center gap-2 px-4 py-2.5 rounded-lg bg-indigo-600 hover:bg-indigo-700 text-white text-sm font-semibold transition-colors duration-200">
            <Download className="h-4 w-4" /> Exporter CSV
          </button>
        )}
      </PageHeader>
      {orders.length === 0 ? <EmptyState title="Aucune commande" icon={ClipboardList} /> : (
        <div className="bg-white border border-slate-200 rounded-xl overflow-hidden overflow-x-auto">
          <table className="w-full text-sm">
            <thead className="bg-slate-50 text-slate-500 text-left">
              <tr>
                <th className="px-5 py-3 font-semibold">Pharmacie</th>
                <th className="px-5 py-3 font-semibold">Opération</th>
                <th className="px-5 py-3 font-semibold">Grossiste livreur</th>
                <th className="px-5 py-3 font-semibold">Articles</th>
                <th className="px-5 py-3 font-semibold text-right">Total</th>
                <th className="px-5 py-3 font-semibold">Date</th>
                <th className="px-5 py-3 font-semibold">Livraison</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-100">
              {orders.map((o) => (
                <tr key={o.id} data-testid={`sup-order-${o.id}`} className="hover:bg-slate-50 transition-colors duration-200">
                  <td className="px-5 py-3 font-semibold text-slate-900">{o.pharmacist_name}</td>
                  <td className="px-5 py-3 text-slate-600">{o.operation_name}</td>
                  <td className="px-5 py-3 text-slate-600 font-medium">{o.grossiste_name || "—"}</td>
                  <td className="px-5 py-3 text-slate-500 num">{o.items?.length}</td>
                  <td className="px-5 py-3 text-right num font-bold text-slate-900">{fmtDT(o.total_amount)}</td>
                  <td className="px-5 py-3 text-slate-400">{fmtDate(o.created_at)}</td>
                  <td className="px-5 py-3">
                    <div className="flex items-center gap-2">
                      <DeliveryBadge status={o.delivery_status} />
                      <DeliveryUpdater participationId={o.id} current={o.delivery_status || "ordered"} onUpdated={(s) => onUpdated(o.id, s)} testId={`sup-set-delivery-${o.id}`} />
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
